'use client';

import { faExclamation, faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { Route } from 'next';
import Link from 'next/link';
import ImageView from '../../../../components/ui/ImageView/ImageView';
import fontsStyles from '../../../../styles/modules/fonts.module.scss';
import utilsStyles from '../../../../styles/modules/utils.module.scss';
import { isVersion } from '../../../../utils/version';
import type { LotteryDrawResultLineup } from '../../types';
import { prizeList2goodsList } from '../../utils';
import styles from './LotteryDrawResultSingle.module.scss';

export type LotteryDrawResultSingleProps = {
  items: Array<LotteryDrawResultLineup>;
  version?: string | null;
  cutoffId?: number | null;
  showPrizeLabel?: boolean;
  isDisplayPrizeOptionIcon?: boolean;
};

function LotteryDrawResultSingle({
  items,
  version,
  cutoffId,
  showPrizeLabel = true,
  isDisplayPrizeOptionIcon = true,
}: LotteryDrawResultSingleProps) {
  const goods = prizeList2goodsList(items)[0];

  const getHref = (): Route => {
    if (isVersion(version, '2.0')) {
      return `/account/collection/${goods.id}?cutoffId=${cutoffId ?? ''}` as Route;
    }
    return `/account/collection/${goods.id}?deliveryId=${goods.deliveryId ?? ''}` as Route;
  };
  const isDisplayIcon = goods.isPrizeOption && isDisplayPrizeOptionIcon;

  return (
    <div className={styles.componentStyle}>
      <Link className={styles.itemLink} href={getHref()}>
        <div className={styles.imageWrapper}>
          <div className={styles.itemImage}>
            {isDisplayIcon && (
              <span className={styles.prizeOptionIcon}>
                <FontAwesomeIcon icon={faPlay} className={styles.triangleIcon} />
                <FontAwesomeIcon icon={faExclamation} className={styles.exclamationIcon} />
              </span>
            )}
            <ImageView src={goods.imageUrl} />
          </div>
          {/* 演出 */}
          {showPrizeLabel && (
            <>
              <div className={`${styles.stagingRank} ${styles[`rank${goods.stagingRank}`]}`} />
              <div className={`${styles.stagingText} ${fontsStyles.montserrat}`}>
                {goods.stagingText}
                <small>賞</small>
              </div>
              <div className={`${styles.stagingStar} ${styles[`rank${goods.stagingRank}`]}`} />
            </>
          )}
        </div>
        <div className={`${styles.itemName} ${utilsStyles.textBold}`} data-testid='lottery-prize-name'>
          {goods.name}
        </div>
      </Link>
    </div>
  );
}

export default LotteryDrawResultSingle;
